// Header.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { name: "Projeler", path: "/projects" },
    { name: "Hakkımızda", path: "/about" },
    { name: "Blog", path: "/blog" },
    { name: "İletişim", path: "/contact" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-[#252f91]/90 backdrop-blur-md border-b border-gray-700 shadow-sm">
      <div className="w-full">
        {/* Desktop & Mobile container */}
        <div className="max-w-[1200px] mx-auto px-4 py-2">
          {/* Desktop */}
          <div className="hidden md:flex items-center justify-between">
            {/* Logo */}
            <div className="h-20">
              <Link to="/" aria-label="Anasayfa">
                <img
                  src={`${process.env.PUBLIC_URL}/log3.svg`}
                  alt="Demiray Mimarlık"
                  className="h-full object-contain brightness-0 invert"
                />
              </Link>
            </div>

            {/* Menu */}
            <nav className="flex space-x-8 text-sm font-medium uppercase tracking-wide text-white">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    aria-current={isActive ? "page" : undefined}
                    className={[
                      "relative inline-block pb-2 text-sm transition-transform duration-300",
                      "hover:scale-[1.03]",
                      isActive
                        ? "text-[#a5c9ff]"
                        : "text-white hover:text-[#a0bce5]",
                      "after:content-[''] after:absolute after:left-0 after:bottom-0",
                      "after:h-[2px] after:transition-all after:duration-500 after:ease-in-out",
                      isActive
                        ? "after:w-full after:bg-[#a5c9ff]"
                        : "after:w-0 after:bg-[#a5c9ff] hover:after:w-full",
                    ].join(" ")}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </nav>
          </div>

          {/* Mobile */}
          <div className="md:hidden flex items-center justify-between">
            <div className="w-8" />
            <div className="h-16 flex-1 flex justify-center">
              <Link to="/" aria-label="Anasayfa">
                <img
                  src={`${process.env.PUBLIC_URL}/logMob.svg`}
                  alt="Demiray Mimarlık"
                  className="h-full object-contain brightness-0 invert"
                />
              </Link>
            </div>

            {/* Hamburger */}
            <button
              aria-label="Menüyü aç/kapat"
              onClick={() => setIsMobileMenuOpen((s) => !s)}
              className="w-8 h-8 flex flex-col justify-center items-center space-y-1"
            >
              <span
                className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                  isMobileMenuOpen ? "rotate-45 translate-y-2" : ""
                }`}
              />
              <span
                className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                  isMobileMenuOpen ? "opacity-0" : ""
                }`}
              />
              <span
                className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                  isMobileMenuOpen ? "-rotate-45 -translate-y-2" : ""
                }`}
              />
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        <div
          className={`md:hidden bg-[#3B3561]/95 backdrop-blur-md border-t border-gray-700 transition-all duration-300 ${
            isMobileMenuOpen
              ? "max-h-64 opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          <nav className="max-w-[1200px] mx-auto px-6 py-4 flex justify-evenly">
            {menuItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  aria-current={isActive ? "page" : undefined}
                  className={[
                    "relative inline-block pb-1 uppercase text-sm font-medium tracking-wide transition-colors duration-300",
                    isActive
                      ? "text-[#a5c9ff]"
                      : "text-white hover:text-[#a5c9ff]",
                    "after:content-[''] after:absolute after:left-0 after:-bottom-0.5",
                    "after:h-[2px] after:transition-all after:duration-500 after:ease-in-out",
                    isActive
                      ? "after:w-full after:bg-[#a5c9ff]"
                      : "after:w-0 after:bg-[#a5c9ff] hover:after:w-full",
                  ].join(" ")}
                >
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
